let FORMS = null

const buildForm = (path, formData = {}, target = '_self') => {
  const form = document.createElement('form')

  form.setAttribute('method', formData.type || 'POST')
  form.setAttribute('action', path)
  form.setAttribute('target', target)

  for (const fieldName in formData.fields) {
    const field = formData.fields[fieldName]
    const isInput = !(field.type === 'select' || field.type === 'textarea')
    const inputType = isInput ? 'input' : field.type
    const input = document.createElement(inputType)

    if (isInput) {
      const fieldType = field.type || 'text'

      input.type = fieldType
    }

    if (field.id) {
      input.id = field.id
    }

    if (field.value || field.value === 0) {
      input.value = field.value
    }

    if (field.type === 'radio') {
      input.setAttribute('checked', 'checked')
    }

    input.name = fieldName

    form.appendChild(input)
  }

  const submit = document.createElement('button')
  submit.setAttribute('type', 'submit')
  form.appendChild(submit)

  if (!FORMS) {
    FORMS = document.createElement('div')

    FORMS.style.display = 'none'

    document.body.appendChild(FORMS)
  }

  FORMS.appendChild(form)

  return form
}

export default buildForm
